module.exports = __webpack_public_path__ + "img/28_48.42c7263c.png";